module.exports = __webpack_public_path__ + "static/media/Avatar__img.2b010ff4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Avatar__img.svg
// module id = 510
// module chunks = 0